var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play_circle_black_24dp",
    transform: "translate(0.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1987",
    "data-name": "Group 1987"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3319",
    "data-name": "Rectangle 3319",
    transform: "translate(-0.018)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1988",
    "data-name": "Group 1988",
    transform: "translate(2.685 2.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8322",
    "data-name": "Path 8322",
    d: "M15.424,2A13.424,13.424,0,1,0,28.847,15.424,13.428,13.428,0,0,0,15.424,2ZM12.068,21.464V9.383l9.4,6.041Z",
    transform: "translate(0 0)",
    fill: "#008001"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.9a8392379b3098b314bb33c1c703b3b1.svg";
export { ForwardRef as ReactComponent };